const EVENT_NAMES = Object.freeze({
  ACTIVATED: 'youtube-livestream:activated',
  DISMISSED: 'youtube-livestream:dismissed',
  MAXIMIZED: 'youtube-livestream:maximized',
  MINIMIZED: 'youtube-livestream:minimized',
});

const Events = {
  Activated: new Event(EVENT_NAMES.ACTIVATED),
  Dismissed: new Event(EVENT_NAMES.DISMISSED),
  Maximized: new Event(EVENT_NAMES.MAXIMIZED),
  Minimized: new Event(EVENT_NAMES.MINIMIZED),
};

export { EVENT_NAMES, Events };
